import React, { useState, useEffect } from 'react'
import * as S from './TabNavigator.styles'
import { useIntl } from 'gatsby-plugin-intl'
import { schedules } from 'components/Schedule/Schedules.mock'
import { dayWithMonth } from 'helpers/Utils'
import Aos from 'aos'
import 'aos/dist/aos.css'

const TabNavigator = () => {
  const { formatMessage, locale } = useIntl()
  const [active, setActive] = useState(0)

  useEffect(() => {
    Aos.init({ duration: 1000 })
  }, [])

  return (
    <S.Wrapper>
      <S.Content>
        <S.TabWrapper>
          {schedules.map((schedule) => (
            <S.TabOption
              key={schedule.day.toString()}
              onClick={() => setActive(schedules.indexOf(schedule))}
              active={schedules.indexOf(schedule) === active}
            >
              <S.OptionTitle active={schedules.indexOf(schedule) === active}>
                {dayWithMonth(schedule.day, locale)}
              </S.OptionTitle>
            </S.TabOption>
          ))}
        </S.TabWrapper>
        <S.TabContent data-aos="fade-in">
          {schedules[active].schedules?.map((schedule) => (
            <S.ContentRow key={schedule.localeId}>
              <S.Time>{`${schedule.start} - ${schedule.end}`}</S.Time>
              <S.Title>
                {formatMessage({
                  id: schedule.localeId,
                })}
              </S.Title>
            </S.ContentRow>
          ))}
        </S.TabContent>
      </S.Content>
    </S.Wrapper>
  )
}

export default TabNavigator
